import { render } from "./send-code.vue?vue&type=template&id=6502d260&scoped=true&ts=true"
import script from "./send-code.vue?vue&type=script&lang=ts"
export * from "./send-code.vue?vue&type=script&lang=ts"

import "./send-code.vue?vue&type=style&index=0&id=6502d260&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6502d260"]])

export default __exports__